export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-star-111a16f4c67ed4507fd9fd58938b7f16.svg";